import { Layer } from './layer.model';

export class Thematic {
   id : string;
   thumbnail : string;
   name: string;
   layersId: string[];
   state: string;
   /*all layers associated with this thematic*/
   layers: Array<Layer> = [];
   source: string;
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/models/thematic.model.ts